// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Distance to MA - Premium Dark Theme */
.ma-container {
  width: 100%;
  padding: 0 8px;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Fixed Header Section */
.ma-fixed-header {
  flex-shrink: 0;
  background: #1a1b23;
}

/* Header */
.ma-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.ma-header .header-title {
  color: #e2e8f0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
}

/* Scrollable Container */
.ma-scroll-container {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 24px;
  padding-top: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

.ma-scroll-container::-webkit-scrollbar {
  width: 5px;
}

.ma-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.ma-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.ma-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Sectors Grid — auto-fill, minimum card width ensures full column headers visible */
.ma-sectors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 8px;
  align-items: start;
}

/* ===== SECTOR CARD ===== */
.ma-sector-card {
  background: #22232b;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.25s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.ma-sector-card:hover {
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transform: translateY(-1px);
}

/* ===== SECTOR HEADER ===== */
.ma-sector-header {
  background: #2a2b35;
  padding: 5px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.ma-sector-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ===== SECTOR TABLE ===== */
.ma-sector-table {
  font-size: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

/* Table Header - 6 columns */
.ma-table-header {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background: #282930;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  font-weight: 700;
  color: #94a3b8;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.ma-table-header .ma-col-symbol {
  text-align: left;
}

.ma-table-header .ma-col-price,
.ma-table-header .ma-col-dist {
  text-align: right;
  color: #FFFFFF;
}

/* Table Body */
.ma-table-body {
  flex: 1 1;
}

/* Table Row - 6 columns */
.ma-table-row {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  transition: background 0.15s ease;
  background: #1e1f27;
}

.ma-table-row:nth-child(even) {
  background: #22232b;
}

.ma-table-row:last-child {
  border-bottom: none;
}

.ma-table-row:hover {
  background: rgba(255, 255, 255, 0.04);
}

/* Shared column properties */
.ma-col-symbol,
.ma-col-price,
.ma-col-dist {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}

/* Symbol Column — 15% */
.ma-col-symbol {
  flex: 0 0 15%;
  font-weight: 600;
  color: #ffffff;
  font-size: 11px;
  text-align: left;
}

/* Price Column — 13% */
.ma-col-price {
  flex: 0 0 13%;
  text-align: right;
  font-weight: 600;
  font-size: 11px;
  color: #ffffff;
  font-variant-numeric: tabular-nums;
}

/* Distance Columns (MA20, MA50, MA90, MA200) — 18% each */
.ma-col-dist {
  flex: 0 0 18%;
  text-align: right;
  font-weight: 600;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  padding: 1px 2px;
  border-radius: 2px;
}

.ma-col-dist.ma-strong-positive {
  color: #4ade80;
}

.ma-col-dist.ma-positive {
  color: #4ade80;
}

.ma-col-dist.ma-negative {
  color: #f87171;
}

.ma-col-dist.ma-strong-negative {
  color: #f87171;
}

.ma-col-dist.ma-neutral {
  color: #64748b;
}

/* ===== LOADING OVERLAY ===== */
.ma-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 27, 35, 0.85);
  z-index: 9999;
  backdrop-filter: blur(4px);
}

/* ===== TOAST NOTIFICATION ===== */
.toast-container {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  animation: toast-slide-in 0.3s ease;
  max-width: 320px;
}

.toast.error {
  background: #2a2b35;
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.toast .toast-message {
  flex: 1 1;
}

.toast .toast-action {
  padding: 4px 10px;
  background: rgba(239, 68, 68, 0.08);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.toast .toast-action:hover {
  background: rgba(239, 68, 68, 0.15);
}

.toast .toast-close {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  line-height: 1;
  transition: color 0.2s ease;
}

.toast .toast-close:hover {
  color: #94a3b8;
}

@keyframes toast-slide-in {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ===== FAB STATS BUTTON ===== */
.fab-stats-btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3) 0%, rgba(79, 70, 229, 0.25) 100%);
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.4);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.fab-stats-btn:hover {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.45) 0%, rgba(79, 70, 229, 0.35) 100%);
  border-color: rgba(99, 102, 241, 0.6);
  color: #c7d2fe;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.25);
  transform: scale(1.08);
}

.fab-stats-btn:active {
  transform: scale(0.95);
}

.fab-stats-btn .fab-tooltip {
  position: absolute;
  right: 56px;
  white-space: nowrap;
  background: rgba(30, 30, 30, 0.95);
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  pointer-events: none;
  opacity: 0;
  transform: translateX(4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fab-stats-btn:hover .fab-tooltip {
  opacity: 1;
  transform: translateX(0);
}

/* ===== STATS MODAL ===== */
.stats-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.stats-modal {
  background: #1a1b23;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  width: 90%;
  max-width: 580px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  animation: modalSlideIn 0.2s ease;
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: translateY(16px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.stats-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.stats-modal-header h3 {
  margin: 0;
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 600;
}

.stats-close-btn {
  background: none;
  border: none;
  color: #64748b;
  font-size: 22px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  transition: color 0.15s;
}

.stats-close-btn:hover {
  color: #e2e8f0;
}

.stats-modal-body {
  padding: 12px 20px 20px;
  overflow-y: auto;
}

/* Stats Table */
.stats-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.stats-table th {
  padding: 8px 10px;
  text-align: center;
  color: #94a3b8;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.stats-table th.stats-col-name {
  text-align: left;
  width: 30%;
}

.stats-table td {
  padding: 7px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.stats-col-name {
  color: #e2e8f0;
  font-weight: 500;
  text-align: left;
}

.stats-pct {
  text-align: center;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #64748b;
}

.stats-pct.pct-high {
  color: #4ade80;
}

.stats-pct.pct-mid {
  color: #fbbf24;
}

.stats-pct.pct-low {
  color: #f87171;
}

/* Total row */
.stats-total-row {
  border-top: 2px solid rgba(255, 255, 255, 0.15);
}

.stats-total-row .stats-col-name {
  font-weight: 700;
  color: #ffffff;
}

.stats-total-row .stats-pct {
  font-weight: 700;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .ma-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 520px) {
  .ma-table-header,
  .ma-table-row {
    padding: 3px 5px;
  }

  .ma-col-symbol {
    font-size: 12px;
  }

  .ma-col-price {
    font-size: 12px;
  }

  .ma-col-dist {
    font-size: 12px;
    padding: 1px 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DistanceToMA.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mEAAmE;EACnE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6FAA6F;EAC7F,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,8FAA8F;EAC9F,qCAAqC;EACrC,cAAc;EACd,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Distance to MA - Premium Dark Theme */\n.ma-container {\n  width: 100%;\n  padding: 0 8px;\n  position: relative;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Fixed Header Section */\n.ma-fixed-header {\n  flex-shrink: 0;\n  background: #1a1b23;\n}\n\n/* Header */\n.ma-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.ma-header .header-title {\n  color: #e2e8f0;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n\n/* Scrollable Container */\n.ma-scroll-container {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 24px;\n  padding-top: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n.ma-scroll-container::-webkit-scrollbar {\n  width: 5px;\n}\n\n.ma-scroll-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ma-scroll-container::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.ma-scroll-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Sectors Grid — auto-fill, minimum card width ensures full column headers visible */\n.ma-sectors-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 8px;\n  align-items: start;\n}\n\n/* ===== SECTOR CARD ===== */\n.ma-sector-card {\n  background: #22232b;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  transition: all 0.25s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.ma-sector-card:hover {\n  border-color: rgba(255, 255, 255, 0.12);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transform: translateY(-1px);\n}\n\n/* ===== SECTOR HEADER ===== */\n.ma-sector-header {\n  background: #2a2b35;\n  padding: 5px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.ma-sector-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* ===== SECTOR TABLE ===== */\n.ma-sector-table {\n  font-size: 10px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Table Header - 6 columns */\n.ma-table-header {\n  display: flex;\n  align-items: center;\n  padding: 4px 6px;\n  background: #282930;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  font-weight: 700;\n  color: #94a3b8;\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n\n.ma-table-header .ma-col-symbol {\n  text-align: left;\n}\n\n.ma-table-header .ma-col-price,\n.ma-table-header .ma-col-dist {\n  text-align: right;\n  color: #FFFFFF;\n}\n\n/* Table Body */\n.ma-table-body {\n  flex: 1;\n}\n\n/* Table Row - 6 columns */\n.ma-table-row {\n  display: flex;\n  align-items: center;\n  padding: 4px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n  transition: background 0.15s ease;\n  background: #1e1f27;\n}\n\n.ma-table-row:nth-child(even) {\n  background: #22232b;\n}\n\n.ma-table-row:last-child {\n  border-bottom: none;\n}\n\n.ma-table-row:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n/* Shared column properties */\n.ma-col-symbol,\n.ma-col-price,\n.ma-col-dist {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n/* Symbol Column — 15% */\n.ma-col-symbol {\n  flex: 0 0 15%;\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 11px;\n  text-align: left;\n}\n\n/* Price Column — 13% */\n.ma-col-price {\n  flex: 0 0 13%;\n  text-align: right;\n  font-weight: 600;\n  font-size: 11px;\n  color: #ffffff;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Distance Columns (MA20, MA50, MA90, MA200) — 18% each */\n.ma-col-dist {\n  flex: 0 0 18%;\n  text-align: right;\n  font-weight: 600;\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.ma-col-dist.ma-strong-positive {\n  color: #4ade80;\n}\n\n.ma-col-dist.ma-positive {\n  color: #4ade80;\n}\n\n.ma-col-dist.ma-negative {\n  color: #f87171;\n}\n\n.ma-col-dist.ma-strong-negative {\n  color: #f87171;\n}\n\n.ma-col-dist.ma-neutral {\n  color: #64748b;\n}\n\n/* ===== LOADING OVERLAY ===== */\n.ma-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 27, 35, 0.85);\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n}\n\n/* ===== TOAST NOTIFICATION ===== */\n.toast-container {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  animation: toast-slide-in 0.3s ease;\n  max-width: 320px;\n}\n\n.toast.error {\n  background: #2a2b35;\n  color: #f87171;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.toast .toast-message {\n  flex: 1;\n}\n\n.toast .toast-action {\n  padding: 4px 10px;\n  background: rgba(239, 68, 68, 0.08);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.toast .toast-action:hover {\n  background: rgba(239, 68, 68, 0.15);\n}\n\n.toast .toast-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 2px;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.toast .toast-close:hover {\n  color: #94a3b8;\n}\n\n@keyframes toast-slide-in {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* ===== FAB STATS BUTTON ===== */\n.fab-stats-btn {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3) 0%, rgba(79, 70, 229, 0.25) 100%);\n  color: #a5b4fc;\n  border: 1px solid rgba(99, 102, 241, 0.4);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.fab-stats-btn:hover {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.45) 0%, rgba(79, 70, 229, 0.35) 100%);\n  border-color: rgba(99, 102, 241, 0.6);\n  color: #c7d2fe;\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.25);\n  transform: scale(1.08);\n}\n\n.fab-stats-btn:active {\n  transform: scale(0.95);\n}\n\n.fab-stats-btn .fab-tooltip {\n  position: absolute;\n  right: 56px;\n  white-space: nowrap;\n  background: rgba(30, 30, 30, 0.95);\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 10px;\n  border-radius: 6px;\n  pointer-events: none;\n  opacity: 0;\n  transform: translateX(4px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.fab-stats-btn:hover .fab-tooltip {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* ===== STATS MODAL ===== */\n.stats-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.15s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.stats-modal {\n  background: #1a1b23;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  width: 90%;\n  max-width: 580px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n  animation: modalSlideIn 0.2s ease;\n}\n\n@keyframes modalSlideIn {\n  from { opacity: 0; transform: translateY(16px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.stats-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.stats-modal-header h3 {\n  margin: 0;\n  color: #e2e8f0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.stats-close-btn {\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.stats-close-btn:hover {\n  color: #e2e8f0;\n}\n\n.stats-modal-body {\n  padding: 12px 20px 20px;\n  overflow-y: auto;\n}\n\n/* Stats Table */\n.stats-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.stats-table th {\n  padding: 8px 10px;\n  text-align: center;\n  color: #94a3b8;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.stats-table th.stats-col-name {\n  text-align: left;\n  width: 30%;\n}\n\n.stats-table td {\n  padding: 7px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.stats-col-name {\n  color: #e2e8f0;\n  font-weight: 500;\n  text-align: left;\n}\n\n.stats-pct {\n  text-align: center;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: #64748b;\n}\n\n.stats-pct.pct-high {\n  color: #4ade80;\n}\n\n.stats-pct.pct-mid {\n  color: #fbbf24;\n}\n\n.stats-pct.pct-low {\n  color: #f87171;\n}\n\n/* Total row */\n.stats-total-row {\n  border-top: 2px solid rgba(255, 255, 255, 0.15);\n}\n\n.stats-total-row .stats-col-name {\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.stats-total-row .stats-pct {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .ma-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 520px) {\n  .ma-table-header,\n  .ma-table-row {\n    padding: 3px 5px;\n  }\n\n  .ma-col-symbol {\n    font-size: 12px;\n  }\n\n  .ma-col-price {\n    font-size: 12px;\n  }\n\n  .ma-col-dist {\n    font-size: 12px;\n    padding: 1px 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
